import { Col, Row, theme, Typography } from "antd";
import { Icons } from "../assets/icons";
import SectionOne from "../components/ActionsOverviewSections/SectionOne";
import SectionTwo from "../components/ActionsOverviewSections/SectionTwo";
import FooterQuoteCard from "../components/ui/FooterQuoteCard";
import PageHeader from "../components/ui/PageHeader";
import { ICON_SIZE } from "../repository/data.default";

const footerText = ` When there are consistent failures to recognize and accommodate the legitimate health and safety needs, and the rights and claims o workers, risks to psychological health can arise. Perceptions of such
          failure can lead to feelings that the work is inherently unsafe and
          risks are ignored or inadequately controlled by choice or ignorance by
          workplace decision makers.`;

function ActionsOverviewPage() {
  const { token } = theme.useToken();
  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      {/* Header */}
      <PageHeader
        title={"OVERVIEW"}
        icon={
          <Icons.ActionsOverviewIcon width={ICON_SIZE} height={ICON_SIZE} />
        }
      />
      {/* Sections */}
      <SectionOne />
      <SectionTwo />
      <FooterQuoteCard
        text={footerText}
        icon={<Icons.ActionsOverviewFooterIcon width={350} height={350} />}
      />
    </Col>
  );
}

export default ActionsOverviewPage;
